var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "#E9E9F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4999 44.9995C63.4999 50.2462 59.2466 54.4995 53.9999 54.4995C48.7532 54.4995 44.4999 50.2462 44.4999 44.9995C44.4999 39.7528 48.7532 35.4995 53.9999 35.4995C59.2466 35.4995 63.4999 39.7528 63.4999 44.9995Z",
    fill: "#9A9AB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3981 60.8976C46.2102 58.0855 50.0231 56.5037 54 56.4995C57.9769 56.5037 61.7898 58.0855 64.6019 60.8976C67.4141 63.7097 68.9958 67.5226 69 71.4995C69 71.7647 68.8946 72.0191 68.7071 72.2066C68.5196 72.3942 68.2652 72.4995 68 72.4995H40C39.7348 72.4995 39.4804 72.3942 39.2929 72.2066C39.1054 72.0191 39 71.7647 39 71.4995C39.0042 67.5226 40.5859 63.7097 43.3981 60.8976Z",
    fill: "#9A9AB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/userAvatar.be103c5af06fc006c1df5e363190054a.svg";
export { ForwardRef as ReactComponent };